import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Header } from "@/widgets/Header";
import { useCardEnrollmentStatusHandler } from "@/shared/hooks/useCardEnrollmentStatusHandler";

function RootLayout() {
  useCardEnrollmentStatusHandler();

  return (
    <div className="AppProvider">
      <Header />
      <Outlet />
    </div>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
});
